export const apiErrors = {
  ERR_NOT_LOGGED_IN: 'Your session has ended. Please login again.',
  ERR_SESSION_EXPIRED: 'Your session has ended. Please login again.',
  ERR_USER_ARCHIVED: 'Your user has been archived',
  ERR_ANALYTICS_NO_PERMISSION:
    "You don't have permission to view analytics data",
  ERR_WORKSPACE_MISSING_ID: 'Missing workspace id',
  ERR_WORKSPACE_MISSING_NAME: 'Missing workspace name',
  ERR_WORKSPACE_NOT_FOUND: 'Workspace not found',
  ERR_SERIES_MISSING_TITLE: 'Missing series title',
  ERR_GROUP_MISSING_NAME: 'Missing group name'
}
